import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'primereact/button';

const DimensionsEditButtons = ({ onSave, onCancel, submitDisabled }) => (
  <div>
    <FormattedMessage id="actions.save" defaultMessage="Save">
      {text => <Button type="button" label={text} disabled={submitDisabled} onClick={onSave} />}
    </FormattedMessage>

    <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
      {text => <Button type="button" label={text} className="p-button-secondary" onClick={onCancel} />}
    </FormattedMessage>
  </div>
);

DimensionsEditButtons.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  submitDisabled: PropTypes.bool,
};

DimensionsEditButtons.defaultProps = {
  submitDisabled: false,
};

export default DimensionsEditButtons;
